import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useRef,
} from "react";
import { useOidc, useOidcAccessToken } from "@axa-fr/react-oidc";
import axiosInstance from "../utils/axiosConfig";

const UserContext = createContext(null);

export const UserProvider = ({ children }) => {
  const { isAuthenticated } = useOidc();
  const { accessToken } = useOidcAccessToken();
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const prevTokenRef = useRef(null);

  const fetchUser = async () => {
    if (!isAuthenticated || !accessToken) {
      setUser(null);
      setError(null);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      setError(null);

      const response = await axiosInstance.get("/user/");
      setUser(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching user info:", err);
      setError(err);
      setLoading(false);
    }
  };

  const refreshUser = () => {
    fetchUser();
  };

  useEffect(() => {
    // Skip re-fetching if the token hasn't actually changed
    // This prevents unnecessary API calls during silent renewal
    if (accessToken && accessToken === prevTokenRef.current) {
      return;
    }
    prevTokenRef.current = accessToken;

    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticated, accessToken]);

  return (
    <UserContext.Provider value={{ user, loading, error, refreshUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  const context = useContext(UserContext);
  if (!context) {
    throw new Error("useUser must be used within UserProvider");
  }
  return context;
};
